class GlobalStore {
	constructor() {
		this.setStore()
	}

	setStore () {
		this.storage = {
			communityName: localStorage.getItem('communityName'),
			communityUid: localStorage.getItem('communityUid'),
			access: localStorage.getItem('access'),
			refresh: localStorage.getItem('refresh'),
			guestCode: localStorage.getItem('guestCode'),
			authorized: localStorage.getItem('authorized')
		}
	}

	getStore() {
		return this.storage
	}

	setItem(key, value) {
		console.log(key, value)
		this.storage[key] = value
		localStorage.setItem(key, value)
	}

	removeItem(key) {
		delete this.storage[key]
		localStorage.removeItem(key)
	}

	clear() {
		this.storage = {}
		localStorage.clear()
	}
}

export default new GlobalStore()